import MapperBase from './MapperBase.js';
import * as Enums from '../enums/index.js';

class TransposedResultsMapper extends MapperBase {
    constructor(silent, fallback, resultType, dataProperty) {
        super(silent, fallback);

        this.dataProperty = dataProperty || Enums.ResultData.Data.key;
        this.resultType = resultType;

        this.resultTemplate = null;
    }

    getResultTemplate() {
        if (!this.resultTemplate){
            const resultProps = Object.keys(Enums.ResultData);
            this.resultTemplate = {};
    
            for (let p = 0; p < resultProps.length; p++) {
                const property = resultProps[p];

                if (property === this.dataProperty || typeof(Enums.ResultData[property]) !== 'object' || !Enums.ResultData[property].hasOwnProperty('key')) {
                    continue;
                }

                this.resultTemplate[Enums.ResultData[property].key] = null;
            }
    
            this.resultTemplate[Enums.ResultData.Type.key] = this.resultType;
            //this.resultTemplate[this.dataProperty] = {};
        }

        return Object.assign({[this.dataProperty]: {}}, this.resultTemplate);
    }

    map(item) {
        const properties = Object.keys(item);
        const firstProperty = properties.find(p => p !== this.dataProperty);
        const totalResults = item[firstProperty].length;

        const mapped = [];
        for (let i = 0; i < totalResults; i++) {
            try {
                const result = this.getResultTemplate();

                for (let p = 0; p < properties.length; p++) {
                    const property = properties[p];
                    if (property === this.dataProperty){
                        this.mapData(item, i, result);
                        continue;
                    }

                    result[property] = item[property][i];
                }

                mapped.push(result);
            } catch (error) {
                this.handleMappingError(error, mapped, item, i);
            }
        }

        return mapped;
    }

    mapData(results, index, result){
        const dataProps = results[this.dataProperty];
        for (const key in dataProps) {
            if (dataProps.hasOwnProperty(key)) {
                result[this.dataProperty][key] = dataProps[key][index];
            }
        }

        return result;
    }
}

export default TransposedResultsMapper;
